import { render, staticRenderFns } from "./WorkflowAdd.vue?vue&type=template&id=fd06d302&scoped=true&"
import script from "./WorkflowAdd.vue?vue&type=script&lang=js&"
export * from "./WorkflowAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd06d302",
  null
  
)

export default component.exports